const BaseModel = require('./BaseModel');

class Contact extends BaseModel {
  static basePath = '/api/v1/contacts';
  static dataType = 'contact';

  get name() { return ([this.firstName, this.lastName].filter(Boolean).join(' ')) }
}

BaseModel.models[Contact.dataType] = Contact;
module.exports = Contact;
